import type { LocaleCode, LocalizedList, LocalizedString } from "@/types/sections";

export const SUPPORTED_LOCALES: LocaleCode[] = ["fr", "en"];

export const pickLocalizedString = (
  value: LocalizedString | string | undefined,
  locale: LocaleCode,
  fallback = ""
): string => {
  if (!value) return fallback;
  if (typeof value === "string") return value;
  return value[locale] ?? value.en ?? value.fr ?? fallback;
};

export const pickLocalizedList = (
  value: LocalizedList | string[] | undefined,
  locale: LocaleCode
): string[] => {
  if (!value) return [];
  if (Array.isArray(value)) return value;
  return value[locale] ?? value.en ?? value.fr ?? [];
};
